export default __webpack_public_path__ + "static/coffee-beans-7f50cf0c6e2efeb5ff23e8b373e4c9b9.png";